import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { MILESTONES } from './Celebrations'

const MILESTONES_DISPLAY = [
  { day: 7, label: 'Foundation', icon: '🏗️' },
  { day: 14, label: 'Activation', icon: '⚡' },
  { day: 21, label: 'Momentum', icon: '🚀' },
  { day: 30, label: 'The Zone', icon: '🎯' },
  { day: 45, label: 'Interview', icon: '💼' },
  { day: 60, label: 'Offer', icon: '🎉' },
]

export default function Progress({ session, profile, currentDay, activeDays, earnedMilestones, onBack }) {
  const [weeklyActivity, setWeeklyActivity] = useState([])

  useEffect(() => { loadActivity() }, [])

  async function loadActivity() {
    const { data } = await supabase.from('daily_completions').select('completed_at').eq('user_id', session.user.id)
    if (data) {
      const uniqueDays = new Set(data.map(d => d.completed_at.split('T')[0]))
      const last7 = []
      for (let i = 6; i >= 0; i--) {
        const d = new Date()
        d.setDate(d.getDate() - i)
        const key = d.toISOString().split('T')[0]
        last7.push({ date: key, active: uniqueDays.has(key), label: ['S', 'M', 'T', 'W', 'T', 'F', 'S'][d.getDay()] })
      }
      setWeeklyActivity(last7)
    }
  }

  const progressPct = (currentDay / 60) * 100
  const earned = earnedMilestones || []

  return (
    <div>
      {onBack && (
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#00712D', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', padding: 0, marginBottom: '0.85rem' }}>
          ← Back to My Search
        </button>
      )}
      <h2 className="section-title">Your Progress</h2>

      {/* Active days — primary metric */}
      <div className="card" style={{ marginBottom: '1rem', textAlign: 'center', padding: '2rem' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: '4.5rem', fontWeight: 700, color: '#00712D', lineHeight: 1 }}>{activeDays}</div>
        <div style={{ fontSize: '0.875rem', color: '#555', fontWeight: 600, marginTop: '0.4rem' }}>Active Search Days</div>
        <div style={{ fontSize: '0.75rem', color: '#aaa', marginTop: '0.2rem' }}>Days you completed at least one task</div>
        <div style={{ marginTop: '1rem', fontSize: '0.78rem', color: '#888', fontStyle: 'italic', lineHeight: 1.5 }}>
          Rest is not quitting. A search that takes breaks is better than one that burns out.
        </div>
      </div>

      {/* 60-day arc */}
      <div className="card" style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.6rem' }}>
          <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#555' }}>60-Day Journey</div>
          <div style={{ fontSize: '0.75rem', color: '#888' }}>Day {currentDay} of 60</div>
        </div>
        <div style={{ height: '10px', background: '#e8e8e8', borderRadius: '5px', overflow: 'hidden', marginBottom: '0.5rem' }}>
          <div style={{ height: '100%', width: `${Math.min(progressPct, 100)}%`, background: 'linear-gradient(90deg, #00712D, #00a040)', borderRadius: '5px', transition: 'width 0.5s' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {MILESTONES_DISPLAY.map(m => (
            <div key={m.day} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '0.9rem', opacity: currentDay >= m.day ? 1 : 0.25 }}>{m.icon}</div>
              <div style={{ fontSize: '0.58rem', color: currentDay >= m.day ? '#00712D' : '#ccc', marginTop: '0.1rem' }}>{m.day}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Last 7 days */}
      <div className="card" style={{ marginBottom: '1rem' }}>
        <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#555', marginBottom: '0.75rem' }}>Last 7 Days</div>
        <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'space-between' }}>
          {weeklyActivity.map((day, i) => (
            <div key={i} style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ width: '100%', paddingBottom: '100%', position: 'relative', borderRadius: '6px', background: day.active ? '#00712D' : '#f0f0f0', marginBottom: '0.3rem' }}>
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', color: '#fff' }}>
                  {day.active ? '✓' : ''}
                </div>
              </div>
              <div style={{ fontSize: '0.62rem', color: '#aaa' }}>{day.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Milestones / Badges */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#555' }}>Milestones</div>
          <span className="badge badge-green">{earned.length} of {MILESTONES.length} earned</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.75rem' }}>
          {MILESTONES.map(m => {
            const isEarned = earned.includes(m.id)
            return (
              <div key={m.id} style={{ textAlign: 'center', opacity: isEarned ? 1 : 0.3 }} title={m.message}>
                <div style={{ fontSize: '1.6rem', marginBottom: '0.2rem', filter: isEarned ? 'none' : 'grayscale(100%)' }}>{m.emoji}</div>
                <div style={{ fontSize: '0.58rem', color: isEarned ? '#00712D' : '#ccc', fontWeight: isEarned ? 700 : 400, lineHeight: 1.2 }}>{m.title}</div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
